import { useEffect, useState } from "react";
import style from "./Chatroom.module.css";
import { adminRequester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import Inline from "layouts/container/Inline";
import CustomIcon from "components/icons/CustomIcon";
import ProgressBar from "../../article/progressBar/ProgressBar";
import Center from "layouts/wrapper/Center";
function LatestChatroom() {
  const [mounted, setMounted] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (mounted) {
      adminRequester.getChatroomStatus({ status: "list", limit: 5 }, (result) =>
        setData(result.data)
      );
    }
  }, [mounted]);
  
  const openEdit = ({ row }) => {};
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex gap={10}>
              <FlexChild width={"max-content"}>
                <CustomIcon name={"articleOperStatus"} width={20} />
              </FlexChild>
              <FlexChild>
                <P>최신 관리자 채팅방</P>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <VerticalFlex>
            {data &&
              data.map((row, index) => (
                <FlexChild>
                  <div
                    className={index % 2 === 0 ? style.evenRow : style.oddRow}
                  >
                    {/* <Center width={"100%"} textAlign={"left"}> */}
                    <HorizontalFlex>
                      <FlexChild width="max-content">
                        <Inline>
                          <P
                            color={"#5471e6"}
                            hover
                            cursor
                            onClick={() => openEdit({ row: row })}
                          >
                            {`[${row.title}] `}
                          </P>
                          <P
                            hover
                            cursor
                            onClick={() => openEdit({ row: row })}
                          >
                            {row?.chats?.length > 0
                              ? row.chats[0].message
                              : "최신 메시지가 없습니다."}
                          </P>
                        </Inline>
                      </FlexChild>
                      <FlexChild width="max-content">
                        <P>{row.updated_at?.replace("T", " ").slice(0, 16)}</P>
                      </FlexChild>
                    </HorizontalFlex>
                    {/* </Center> */}
                  </div>
                </FlexChild>
              ))}
          </VerticalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}
export default LatestChatroom;
